import { Grid, Box } from '@mui/material';

import { Typography, Card, CardContent, CardHeader } from '@occc/ui-design-system';

import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import { LocationFormRenderProps } from './types';

import LocationDetailsFormContent from '../components/LocationDetailsFormContent';
import LocationAddressFormContent from '../components/LocationAddressFormContent';
import LocationPluginFormContent from '../components/LocationPluginFormContent';
import LocationAttributesFormContent from '../components/LocationAttributesFormContent';
import { LocationGroupMultiSelect } from '../components/LocationGroupMultiSelect';

export const LocationCreateForm = ({
  handleSubmit,
}: Pick<LocationFormRenderProps, 'handleSubmit'>) => {
  const isUserPermittedToAddLocationToGroup = useIsUserPermittedTo(Feature.LOCATION_ADD_TO_GROUP);

  return (
    <form onSubmit={handleSubmit}>
      <Box mb={1}>
        <Card>
          <CardHeader title={<Typography variant='h6'>Site Info</Typography>} />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={3}>
                <LocationDetailsFormContent locationCreate />
              </Grid>
              <Grid item xs={12} sm={3}>
                <LocationPluginFormContent />
              </Grid>
              {isUserPermittedToAddLocationToGroup && (
                <Grid item xs={12} sm={6}>
                  <LocationGroupMultiSelect />
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>

      <Box mb={1}>
        <Card>
          <CardHeader title={<Typography variant='h6'>Address</Typography>} />
          <CardContent>
            <LocationAddressFormContent />
          </CardContent>
        </Card>
      </Box>

      <Box mb={1}>
        <Card>
          <CardHeader title={<Typography variant='h6'>Attributes</Typography>} />
          <CardContent>
            <LocationAttributesFormContent />
          </CardContent>
        </Card>
      </Box>
    </form>
  );
};
